<template>
    <section v-permission.if="[USER_ROLES.ADMIN,USER_ROLES.SUPER_ADMIN,USER_ROLES.GA_HEAD,USER_ROLES.JOURNEY_MANAGER]">
        <div v-if="loading" class="content content-centered">
            <pulse-loader></pulse-loader>
        </div>
        <div v-show="!loading" class="content">
            <div class="box">
                <div class="box-body">
                    <div class="row">
                        <div class="flash-message col-md-4 col-md-offset-4 text-center" v-if="flash">
                            <div class="alert" :class="'alert-' + flashType">{{ flashMessage }}</div>
                        </div>
                    </div>
                    <div id="details" class="row">
                        <div class="col-sm-12 text-right">
                            <button class="btn btn-danger mr-5" type="button" @click="deleteDriverModal" v-permission.if="[USER_ROLES.ADMIN,USER_ROLES.SUPER_ADMIN,USER_ROLES.GA_HEAD]">Delete Driver</button>
                        </div>
                        <vue-form :state="formstate" @submit.prevent="onSubmit" class="row">
                            <div class="col-sm-12">
                                 <div class="col-sm-6">
                                    <validate auto-label class="form-group required-field" :class="fieldClassName(formstate.driverName)">
                                        <label>Name</label>
                                        <input type="text" minlength="3" maxlength="20" name="driverName" class="form-control" required v-model.lazy="driver.driverName" placeholder="Name">
                                        <field-messages name="driverName" show="$touched || $submitted" class="form-control-feedback">
                                            <div slot="required">Driver name is a required field</div>
                                            <div slot="pattern">Driver Name is invalid</div>
                                            <div slot="minlength">Driver name should be more than 3 characters</div>
                                            <div slot="maxlength">Driver name should be less than 20 characters</div>
                                        </field-messages>
                                    </validate>
                                </div>
                                <div class="col-sm-3">
                                    <validate auto-label class="form-group required-field" :class="fieldClassName(formstate.mobileNumber)">
                                        <label>Mobile Number</label>
                                        <input type="number" min="1000000000" name="mobileNumber" class="form-control" required v-model.lazy="driver.mobileNumber" placeholder="Mobile number" pattern="[78965][0-9]{9}">
                                        <field-messages name="mobileNumber" show="$touched || $submitted" class="form-control-feedback">
                                            <div slot="required">Mobile number is a required field</div>
                                            <div slot="pattern">Mobile number is invalid</div>
                                        </field-messages>
                                    </validate>
                                </div>
                                <div class="col-sm-3">
                                    <validate auto-label class="form-group required-field" :class="fieldClassName(formstate.status)">
                                        <label>Status</label>
                                        <select required v-model="driver.status" name="status" class="form-control">
                                            <option value="" disabled>Select Status</option>
                                            <option value="active">Active</option>
                                            <option value="inactive">Inactive</option>
                                        </select>
                                        <field-messages name="status" show="$touched || $submitted" class="form-control-feedback">
                                            <div slot="required">Status is a required field</div>
                                            <div slot="pattern">Status is invalid</div>
                                        </field-messages>
                                    </validate>
                                </div>
                            </div>
                            <div class="col-sm-12">
                                <div class="col-sm-3">
                                    <validate auto-label class="form-group required-field" :class="fieldClassName(formstate.dateOfBirth)">
                                        <label>Date of Birth</label>
                                        <date-picker :max="this.minDate" id="dateOfBirth" required v-model="driver.dateOfBirth" lang="en" name="dateOfBirth" input-class="form-control" width="100%" use-utc="true" format="DD-MM-YYYY" @change="getEligibleDate"></date-picker>
                                        <field-messages name="dateOfBirth" show="$touched || $submitted" class="form-control-feedback">
                                            <div slot="required">Date of Birth is a required field</div>
                                            <div slot="max">Minimum age is 18 years</div>
                                        </field-messages>
                                    </validate>
                                </div>
                                <div class="col-sm-3">
                                    <validate auto-label class="form-group required-field" :class="fieldClassName(formstate.driverPin)">
                                        <label>Driver Pin</label>
                                        <input type="number" min="1000" max="9999" name="driverPin" class="form-control" required v-model.lazy="driver.driverPin" placeholder="Driver Pin">
                                        <field-messages name="driverPin" show="$touched || $submitted" class="form-control-feedback">
                                            <div slot="required">Driver pin is a required field</div>
                                            <div slot="pattern">Driver pin is invalid</div>
                                            <div slot="min">Driver pin is minimum 4 digit</div>
                                            <div slot="max">Driver pin is Maximum 4 digit</div>
                                        </field-messages>
                                    </validate>
                                </div>
                                <div class="col-sm-3">
                                    <validate auto-label class="form-group required-field" :class="fieldClassName(formstate.region)">
                                        <label>Geographical Area</label>
                                        <select v-model="driver.region" required name="region" class="form-control">
                                            <option value="" disabled>Select G.A</option>
                                            <option v-for="(item,index) in region_list" :key="index" :value="item.key">
                                                {{item.value}}
                                            </option>
                                        </select>
                                        <field-messages name="region" show="$touched || $submitted" class="form-control-feedback">
                                            <div slot="required">Geographical Area is a required field</div>
                                        </field-messages>
                                    </validate>
                                </div>
                                <div class="col-sm-3">
                                    <validate auto-label class="form-group required-field" :class="fieldClassName(formstate.vehicleId)">
                                        <label>Vehicle</label>
                                        <select v-model="driver.vehicleId" required name="vehicleId" class="form-control">
                                            <option value="" disabled>Select Vehicle</option>
                                            <option v-for="(item,index) in vehicle_no" :key="index" :value="item.key">
                                                {{item.value}}
                                            </option>
                                        </select>
                                        <field-messages name="vehicleId" show="$touched || $submitted" class="form-control-feedback">
                                            <div slot="required">Vehicle is a required field</div>
                                        </field-messages>
                                    </validate>
                                </div>
                            </div>
                            <div class="col-sm-12">
                                <div class="col-sm-3">
                                    <validate auto-label class="form-group required-field" :class="fieldClassName(formstate.lisenceNumber)">
                                        <label>License No</label>
                                        <input type="text" maxlength="20" minlength="10" name="lisenceNumber" class="form-control" required v-model.lazy="driver.lisenceNumber" placeholder="License No" v-on:keydown="validateRegistration">
                                        <field-messages name="lisenceNumber" show="$touched || $submitted" class="form-control-feedback">
                                            <div slot="required">License no is a required field</div>
                                            <div slot="pattern">License no is invalid</div>
                                            <div slot="minlength">Minimum length of license no is 10 character</div>
                                        </field-messages>
                                    </validate>
                                </div>
                                <div class="col-sm-3" id="licenseExpiryDiv" >
                                    <validate auto-label class="form-group required-field">
                                        <label for="dateAdded">License Expiry Date</label>                                    
                                        <date-picker required id="licenseExpiryDate" v-model="driver.licenseExpiryDate" lang="en" name="licenseExpiryDate"  width="100%" use-utc="true"  @change="highlight" format="DD-MM-YYYY" ></date-picker>
                                        <field-messages name="licenseExpiryDate" show="$touched || $submitted" class="form-control-feedback">
                                            <div slot="required">License Expiry Date is a required field</div>
                                        </field-messages>
                                    </validate>                                 
                                </div>
                                <div class="col-sm-3">
                                    <validate auto-label class="form-group required-field" :class="fieldClassName(formstate.manager)">
                                        <label>Journey Manager</label>
                                        <select v-model="driver.manager" required name="manager" class="form-control">
                                            <option value="" disabled>Select Journey Manager</option>
                                            <option v-for="(item,index) in manager" :key="index" :value="item.key">
                                                {{item.value}}
                                            </option>
                                        </select>
                                        <field-messages name="manager" show="$touched || $submitted" class="form-control-feedback">
                                            <div slot="required">Journey Manager is a required field</div>
                                        </field-messages>
                                    </validate>
                                </div>
                                <div class="col-sm-3">
                                    <validate auto-label class="form-group required-field" :class="fieldClassName(formstate.deviceId)">
                                        <label>Device</label>
                                        <select v-model="driver.deviceId" required name="deviceId" class="form-control">
                                            <option value="" disabled>Select Device</option>
                                            <option v-for="(item,index) in device_id" :key="index" :value="item.key">
                                                {{item.value}}
                                            </option>
                                        </select>
                                        <field-messages name="deviceId" show="$touched || $submitted" class="form-control-feedback">
                                            <div slot="required">Device is a required field</div>
                                        </field-messages>
                                    </validate>
                                </div>
                            </div>
                            <div class="col-sm-12">
                                <div class="col-sm-6">
                                    <validate auto-label class="form-group required-field" :class="fieldClassName(formstate.languageKnown)">
                                        <label>Language Known</label>
                                        <select v-model="driver.languageKnown" required name="languageKnown" class="form-control">
                                            <option value="" disabled>Select Language</option>
                                            <option v-for="(item,index) in language" :key="index" :value="item.key">
                                                {{item.value}}
                                            </option>
                                        </select>
                                        <field-messages name="languageKnown" show="$touched || $submitted" class="form-control-feedback">
                                            <div slot="required">Language is a required field</div>
                                        </field-messages>
                                    </validate>
                                </div>
                                <div class="col-sm-6">
                                    <validate auto-label class="form-group " :class="fieldClassName(formstate.defaultLanguage)">
                                        <label>Default Language</label>
                                        <select v-model="driver.defaultLanguage"  name="defaultLanguage" class="form-control">
                                            <option value="" disabled>Select Language</option>
                                            <option v-for="(item,index) in language" :key="index" :value="item.key">
                                                {{item.value}}
                                            </option>
                                        </select>
                                    </validate>
                                </div>
                            </div>
                            <div class="col-sm-12">
                                <div class="col-sm-6">
                                    <validate auto-label class="form-group" :class="fieldClassName(formstate.driverImage)">
                                        <label>Driver Photo</label>
                                        <input type="file" @change="onFilechanged" class="form-control" required />
                                        <field-messages name="photo" show="$touched || $submitted" class="form-control-feedback">
                                            <div slot="required">Please upload less than 3mb picture</div>
                                        </field-messages>
                                    </validate>
                                </div>
                                <div class="col-sm-6">
                                    <validate auto-label class="form-group" :class="fieldClassName(formstate.documents)">
                                        <label>Other Document</label>
                                        <input type="file" name="otherInfo" class="form-control" multiple @change="onDocumentchanged">
                                        <field-messages name="otherInfo" show="$touched || $submitted" class="form-control-feedback">
                                            <div slot="required">Please upload less than 3mb document</div>
                                        </field-messages>
                                    </validate>
                                </div>
                            </div>
                            <div class="col-sm-12">                                
                                <div class="col-sm-6">
                                    <validate class="form-group" :class="fieldClassName(formstate.addressDetails)">
                                        <label>Address</label>
                                        <textarea class="form-control" name="addressDetails" v-model.lazy="driver.addressDetails" placeholder="Address">
                                        </textarea>
                                    </validate>
                                </div>
                            </div>
                        </vue-form>
                        <div class="col-sm-12 text-right" >
                            <router-link :to="{ name: 'Driver' }">
                                <button class="mr-5 btn btn-default" type="button" >Cancel</button>
                            </router-link>
                            <button class="mr-2 btn gradientbt" type="submit" @click="updateDriver" :disabled="!(formstate.$dirty && formstate.$invalid)" v-permission.if="[USER_ROLES.ADMIN,USER_ROLES.SUPER_ADMIN,USER_ROLES.GA_HEAD,USER_ROLES.JOURNEY_MANAGER]">Update Driver</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import { formService, eventBus , driverService} from '../../../services'
import { EVENTS } from '../../../config'
import swal from 'sweetalert2'
import { USER_ROLES } from '../../../config';
import { mapState } from 'vuex';


  export default {
    name: 'DriverDetail',
    data () {
       return {
           USER_ROLES: USER_ROLES,
            loading: false,
            flash: false,
            flashType: null,
            flashMessage: '',
            EVENTS: EVENTS,
            formstate: {},
            manager : {},
            vehicle_no : {},
            region_list :{},
            device_id : {},
            selectedFile: null,
            selectedDocument: null,
            form : new FormData,
            expiryDate:'',
            minDate:'',
            driver : {
            },
            language : [
                {
                    key : 'Hindi',
                    value : 'Hindi',
                },
                {
                    key : 'Punjabi',
                    value : 'Punjabi',
                },
                {
                    key : 'English',
                    value : 'English',
                }
            ]
        }
    },
    mounted: function() {
        this.getManagerList()
        this.getRegionList()
        this.getVehicle()
        this.getDevice()
        // this.highlight()

    },
    methods: {
        fieldClassName: formService.fieldClassName,
        getEligibleDate(e){
            let d = new Date();
            d.setMonth(d.getMonth()- 12*18);
            this.minDate = d 
        },
         onFilechanged (event) {
            console.log("hiiiiii",event)
            this.photo = event.target.files[0]
            this.driver.driverImage = event.target.files[0]['name']
        },
        onDocumentchanged (event) {
            this.docs = event.target.files[0]
            this.driver.documents = event.target.files[0]['name']
        },
        getManagerList() {
            this.loading  = true;
            const params  = {}
            params.$limit = 0;
            params.roleRank = 3;
            let managerlist = [];
            this.$userRepository.list(params)
                .then((res)=> {
                    this.loading  = false;
                    if (res.data.docs) {
                        managerlist =  res.data.docs.map((item)=> {
                            return {
                                key : item._id, 
                                value : item.firstName +' '+item.lastName
                            }
                        })
                       
                    }
                    this.manager = managerlist;
                })
                .catch((error) => {
                    this.loading  = false;
                    console.error('Manager.requestFunction-error:', error)
                    this.$snotify.error('Get manager list failed', 'Error!')
                })
        },
          getDevice(){
            this.loading  = true;
            const params  = {}
            params.$limit = 0;
            //params.roleRank = 4;
            let deviceList = [];
            this.$deviceDataRepository.list(params)
                .then((res)=> {
                    this.loading  = false;
                    if (res.data.docs) {
                        deviceList =  res.data.docs.map((item)=> {
                            return {
                                key : item._id, 
                                value : item.deviceId,
                                
                            }
                        })
                       
                    }
                    this.device_id = deviceList;
                    
                })
                .catch((error) => {
                    this.loading  = false;
                    console.error('device.requestFunction-error:', error)
                    this.$snotify.error('Get device list failed', 'Error!')
                })
        },
        onFileSelected(event) {
                    //console.log(event)
            this.selectedFile = event.target.files[0],
            //this.attachment = selectedFile,
            console.log(this.selectedFile)
        },
        onDocumentSelected(event){
            this.selectedDocument = event.target.files[0],
            console.log(this.selectedDocument)

        },
        onUploadPhoto() {
            this.form.append('driver.photo',this.selectedFile)
                    const config ={headers : {'Content-Type' : 'multipart/form-data'}}
                     axios.post('/backend/server/api/uploads/documents', this.form,config)
                        .then((response) => {
                            console.log(response)
                        }).catch((err) => {
 
                        });
 
        },
        onUploadDocument() {
            this.form.append('driver.otherInfo',this.selectedDocument)

                     axios.post('/backend/server/api/uploads/documents', this.form)
                        .then((response) => {
                            console.log(response)
                        }).catch((err) => {
 
                        });
 
        },
        getVehicle(){
            this.loading  = true;
            const params  = {}
            params.$limit = 0;
            if (this.user.roleName == "GA Head"){
                params.regionRegionManager = this.user._id
            }
            //params.roleRank = 4;
            let vehicleList = [];
            this.$vehicleDataRepository.list(params)
                .then((res)=> {
                    this.loading  = false;
                    if (res.data.docs) {
                        vehicleList =  res.data.docs.map((item)=> {
                            return {
                                key : item._id, 
                                value : item.regNo,
                                
                            }
                        })
                       
                    }
                    this.vehicle_no = vehicleList;
                    
                })
                .catch((error) => {
                    this.loading  = false;
                    console.error('vehicle.requestFunction-error:', error)
                    this.$snotify.error('Get vehicle list failed', 'Error!')
                })
        },
            
        getRegionList() {
            this.loading  = true;
            const params  = {}
            params.$limit = 0;
            if (this.user.roleName == "GA Head"){
                params.regionManager = this.user._id
            }
            let regionlist = [];
            this.$regionDataRepository.list(params)
                .then((res)=> {
                    this.loading  = false;
                    if (res.data.docs) {
                        regionlist =  res.data.docs.map((item)=> {
                            return {
                                key : item._id, 
                                value : item.name
                            }
                        })
                       
                    }
                    this.region_list = regionlist;
                })
                .catch((error) => {
                    this.loading  = false;
                    console.error('Region.requestFunction-error:', error)
                    this.$snotify.error('Get region list failed', 'Error!')
                })
        },
        getDriver () {
            this.$driverDataRepository.find(this.$route.params._id)
            .then((response) => {
                console.log('drive', response.data)
                this.driver = response.data;
                this.expiryDate = response.data.licenseExpiryDate;
                console.log("this.expiryDate",this.expiryDate)
                this.highlight(this.expiryDate)
            })
            
        },
        highlight(expiryDate){
            console.log("this.driver.licenseExpiryDate",this.expiryDate)
            let epochExpiryDate = new Date(this.expiryDate).getTime();
            console.log("epochExpiryDate",epochExpiryDate)
            Date.prototype.addDays = function(days) {
                var date = new Date(this.valueOf());
                date.setDate(date.getDate() + days);
                return date;
            }
            let date = new Date()
            let expiredDate = date.addDays(60);
            if (epochExpiryDate < expiredDate.getTime()){
                console.log("e is less than 2 months")
                document.getElementById("licenseExpiryDiv").style.color = 'red';
            }
        },
        highlightAfterUpdate(e){
            console.log(e)
            Date.prototype.addDays = function(days) {
                var date = new Date(this.valueOf());
                date.setDate(date.getDate() + days);
                return date;
            }
            let date = new Date()
            let expiredDate = date.addDays(60);
            if (e.getTime() < expiredDate.getTime()){
                console.log("e is less than 2 months")
                document.getElementById("licenseExpiryDiv").style.color = 'red';
            }
            else {
                document.getElementById("licenseExpiryDiv").style.color = 'black';
            }
        },
        validateRegistration : function(e) {
            let keyCode = e.keyCode || e.which;
            if (keyCode == 32)
                e.preventDefault();
            else 
                this.vehicle = {
                    ...this.vehicle,
                    regNo : e.target.value.toUpperCase()
                }
        },
        updateDriver () {
            this.loading = true;
            return driverService.updateDriver(this.driver)
            .then((response) => {
                this.loading = false
                this.flash = false
                this.$snotify.success('Driver updated!', 'Success!')
                this.$router.push('/driver')
            })
            .catch(error => {
                this.loading = false
                this.$snotify.error('Driver Update failed! Try Again', 'Error!')
                if (error.data.message.includes('must be one of')) {
                    this.flash = true
                    this.flashType = 'error'
                    this.flashMessage = 'New driver add is failed.Please try again!'
                }
            })
        },
        deleteDriverModal () {
            swal({
                title: 'Are you sure?',
                text: 'This will permanently delete this Driver!',
                type: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                customClass: 'swal-modal2',
                width: '400px',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, delete it!',
            }).then((result) => {
                if (result.value) {
                    this.deleteDriver()
                }
            })
        },
        deleteDriver () {
            this.loading = true
            return this.$driverDataRepository.deleteOne(this.driver._id)
            .then((response) => {
                this.loading = false;
                return swal(
                    'Deleted!',
                    'Driver has been deleted.',
                    'success'
                )
            })
            .then((response) => {
                this.loading = false;
                this.$router.push('/driver')
            })
            .catch((error) => {
                this.loading = false;
                this.$snotify.error('Delete driver failed', 'Error!')
            })
        },
        fieldClassName: function (field) {
            if(!field) {
                return '';
            }
            if((field.$touched || field.$submitted) && field.$valid) {
                return 'has-success';
            }
            if((field.$touched || field.$submitted) && field.$invalid) {
                return 'has-danger';
            }
        }
    },
    created() {
        const promises = []
        this.loading = true
        promises.push(this.getDriver())
        Promise.all(promises)
            .then(() => {
                this.loading = false
                this.ready = true
            })
            .catch(() => {
                this.loading = false
            })
    },
    computed:{
        ...mapState({
          user:state =>state.auth.user  
        })
    }
  }
</script>
<style scoped>
    .required-field > label::after  {
        content: '*';
        color: red;
        margin-left: 0.25rem;
    }
    .form-control-feedback {
        font-weight: 100;
        color: red;
        position: initial;
        text-align: left;
        height: auto;
        width: auto;
    }
    .has-danger {
        color: red
    }
    .mt {
        margin-top: 7px;
    }
    .swal-text{
     font-size: 100px !important;
}
.gradientbt{
    background: #0F6940;
  color: white
}
</style>



// WEBPACK FOOTER //
// DriverDetail.vue?4829f2e3